<template>
    <main>
        <div class="container-fluid message">
            <TopTemplate>
                <template #right-element>
                    <router-link :to="{ name: 'listeRdv' }" class="btn btn-outline-primary button" :disabled="loading">
                        <i class="arrow left" />
                        {{ $t("button.retour") }}
                    </router-link>
                </template>
                <template #left-element>
                    <h3>{{ $t("title.addRdv") }}</h3>
                </template>
            </TopTemplate>
            <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
                <div class="spinner-border text-info" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="ajout-container message-add">
                <form novalidate>
                    <div class="row">
                        <div class="col-md-6 custom-label" ref="simpleselect">
                            <label>{{ $t("rdv.add.eleve") }}<sup>*</sup></label>
                            <span class="indice">{{ $t("rdv.add.msgEleve") }}</span>
                            <v-select v-model="rdv.selectedLevel" placeholder="Saisir au moins 3 lettres" :searchable="true"
                                :options="student" label="item_data" class="form-control" :reduce="(option) => option"
                                @update:modelValue="ChangeLevel($event)"
                                :class="{ 'is-invalid': v$.rdv.selectedLevel.$error }">
                                <template #no-options="{ search, searching, loading }">
                                    <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                                        {{ $t("common.emptysearshType") }}
                                    </div>
                                    <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                                        <div class="spinner-border text-info" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                            <span v-if="v$.rdv.selectedLevel.$error" class="invalid-feedback">{{
                                v$.rdv.selectedLevel.$errors[0].$message }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 custom-label">
                            <label>{{ $t("rdv.add.enseignant") }}<sup>*</sup></label>
                            <span class="indice">{{ $t("rdv.add.msgEnseignant") }}</span>
                            <v-select v-model="rdv.selectedTeacher" placeholder="Saisir au moins 3 lettres"
                                :searchable="true" :options="teacher" label="item_data_teacher" class="form-control"
                                :reduce="(option) => option.id"
                                :disabled="disabledClass" :class="{ 'is-invalid': v$.rdv.selectedTeacher.$error }">
                                <template #no-options="{ search, searching, loading }">
                                    <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                                        {{ $t("common.emptysearshType") }}
                                    </div>
                                    <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                                        <div class="spinner-border text-info" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                            <span v-if="v$.rdv.selectedTeacher.$error" class="invalid-feedback">{{
                                v$.rdv.selectedTeacher.$errors[0].$message }}</span>
                        </div>
                    </div>
                    <div class="row custom-label">
                        <label>{{ $t("rdv.add.planning") }}<sup>*</sup></label>
                        <span class="indice">{{ $t("rdv.add.msgPlanning") }}</span>
                        <div class="col-md-3 ">
                            <div class="simple-input">
                                <div>
                                    <Datepicker v-model="rdv.date" class="custom-datepicker" placeholder="Date"
                                         locale="fr" autoApply
                                        :enable-time-picker="false" :min-date="new Date()" :format="format_date_v1"
                                        :class="{ 'is-invalid': v$.rdv.date.$error }" />
                                    <span v-if="v$.rdv.date.$error" class="invalid-feedback">{{
                                        v$.rdv.date.$errors[0].$message }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="simple-input select-wrapper">
                                <input v-model="rdv.selectedHour" type="text" class="form-control" placeholder="Heure"
                                    @input="validateHourFormat" :class="{ 'is-invalid': v$.rdv.selectedHour.$error }" 
                                    @blur="touched = true"/>
                                <span class="indice">Seuls le format HH:MM (10:00)</span>
                                <span v-if="v$.rdv.selectedHour.$error" class="invalid-feedback">{{
                                    v$.rdv.selectedHour.$errors[0].$message }}</span>
                                <p v-if="error && touched" class="invalid-feedback">{{ $t("common.invalidHour") }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-6 custom-label">
                            <label>{{ $t("rdv.add.detail") }} <sup>*</sup></label>
                            <textarea class="form-control p-2" v-model="rdv.description" maxlength="300" placeholder="Sujet"
                                :class="{ 'is-invalid': v$.rdv.description.$error }" />
                            <span v-if="v$.rdv.description.$error" class="invalid-feedback">{{
                                v$.rdv.description.$errors[0].$message }}</span>
                        </div>
                    </div>

                </form>
            </div>
            <div class="col-12 button-envoyer button-rdv text-right">
                <button @click="addRdv()" type="submit" class="btn button btn-primary" :disabled="loading">
                    {{ $t("button.envoiRdv") }}
                </button>
            </div>
        </div>
    </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import RdvClass from "../../services/rdv.service";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import vSelect from "vue-select";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import _ from "lodash";
export default {
    name: "AddRdv",
    components: {
        TopTemplate,
        "v-select": vSelect,
        Datepicker,
    },

    data() {
        return {
            v$: useValidate(),
            showInvalidFormatError: false,
            rdv: [],
            filters: [],
            student: [],
            teacher: [],
            teacher_id: null,
            params: {
                class_type_id: null,
            },
            loading: false,
            error:false,
            touched: false,
            statusAdmin: 4,
        };
    },

    validations() {
        return {
            rdv: {
                selectedTeacher: {
                    required: helpers.withMessage(this.$t("validation.required"), required),
                },
                selectedLevel: {
                    required: helpers.withMessage(this.$t("validation.required"), required),
                },
                date: {
                    required: helpers.withMessage(this.$t("validation.required"), required),
                },
                selectedHour: {
                    required: helpers.withMessage(this.$t("validation.required"), required),
                },
                description: {
                    required: helpers.withMessage(this.$t("validation.required"), required),
                },
            },
        };
    },
    
    computed: {
        disabledClass() {
  const isLevelEmpty = !this.rdv.selectedLevel;
  
  if (isLevelEmpty) {
    this.rdv.selectedTeacher = null;
  }

  return isLevelEmpty;
},


    },

    mounted() {
        this.filter();
    },

    methods: {

        validateHourFormat() {
            const regex = /^([9-9]:[0-5][0-9])|(1[0-7]:[0-5][0-9])|(18:00)$/;
      this.error = !regex.test(this.rdv.selectedHour);  
          },
        ChangeLevel(e) {
            if (e != null) {
                this.params.class_type_id = null;

                this.params.class_type_id = e.class[0].id;
            } else {
                this.params.class_type_id = null;
            }
            this.selectedClass = null;
            this.params.class_school_id = [];
            this.filter();
        },
        ChangeTeacher(e) {
            if (e != null) {
                this.teacher_id = e.id;
            }
        },

        filter() {
            RdvClass.filter({
                params: {
                    class_id: this.params.class_type_id,
                },

            })
                .then((response) => {
                    this.student = response.data.student;
                    this.teacher = response.data.teachers;
                    this.student.map(function (item) {
                        return (item.item_data = item.first_name + " " + item.last_name);
                    });        
                    this.teacher.map(function (item) {
                        return (item.item_data_teacher = item.first_name + " " + item.last_name);
                    });
                })
                .finally(() => {
                });
        },
        format_date_v1(value) {
            if (value) {
                return moment(String(value)).format("DD-MM-YYYY");
            }
        },
        refreshHeaderContent() {
      this.$emit('refresh-header-content');
    },

        addRdv() {
            this.v$.$validate();
            this.showRequired = this.v$.$error;
            if (!this.showInvalidFormatError && !this.v$.$error) {
                this.loading = true;
                const data = {
                    teacher_id: this.rdv.selectedTeacher,
                    student_id: this.rdv.selectedLevel.id,
                    appointment_date_at: this.rdv.date,
                    appointment_time: this.rdv.selectedHour,
                    description: this.rdv.description,
                    status: this.statusAdmin,
                };
                RdvClass.add(data, true)
                    .then((response) => {
                        localStorage.setItem('isEnseignant', true);
                        this.$router.push({ name: "listeRdv" });
                        this.loading = false;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }, dateTime(value) {
            return moment(value).locale("fr").format("YYYY-MM-DD");
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        },
        resetForm() {
            this.selected = "";
        },
    },
};
</script>
<style scoped lang="scss">
.custom-label {
    margin-bottom: 15px;

    label {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0em;
        margin-bottom: 5px;
    }

    .indice {
        margin-bottom: 5px;
    }

    .simple-input {
        margin: 0;
    }

}

.ajout-container {
    margin-bottom: 15px;
}

.button-rdv {
    button {
        background-color: #377879;

        &:hover {
            color: #377879 !important;
            border-color: #377879;
        }
    }
}</style>